import { z } from 'zod';

export const envSchema = z.object({
  VITE_FINTALK_BIOMETRICS_BASE_URL: z.url(),
  VITE_SENTRY_DSN: z.url(),
  VITE_UNICO_SDK_ENVIRONMENT: z.enum(['UAT', 'PROD']),
});

export const env = envSchema.parse(import.meta.env);
